import { OnboardingDraftsApiBase } from './paymentApi';

class DraftsApi extends OnboardingDraftsApiBase {
}

export default new DraftsApi();
